
import { formatCEP, formatCNPJ } from "../../../../../function/utilis/function";
import { FiEdit } from "react-icons/fi";
import "./style.css"
import { Modal, Tooltip } from "antd";
import AtualizarDadosEmpresa from "../AtualizarDadosEmpresa";
import { useState } from "react";


const DadosEmpresa = ({ clienteSelecionado }) => {

  const [isModalAtualizarDadosEmptresa, setIsModalAtualizarDadosEmptresa] = useState(false);

  return (
    <>
      <div className="modal-header">
        <h2>Dados da Empresa</h2>
      </div>

      <div className="modal-body">
        <div className="modal-card">
          <div style={{ display: "flex" }}>
            <div style={{width: "100%"}}>
              <h3>Informações Gerais</h3>
            </div>
            <Tooltip title="Alterar dados">
              <div className="btn-alter">
                <span
                  onClick={() => setIsModalAtualizarDadosEmptresa(true)}
                  className="a-btn"
                >
                  <FiEdit />
                </span>
              </div>
            </Tooltip>
          </div>
          <p><strong>CNPJ:</strong> {formatCNPJ(clienteSelecionado?.cnpj) ?? "-"}</p>
          <p><strong>Razão Social:</strong> {clienteSelecionado?.nome ?? "-"}</p>
        </div>

        <div className="modal-card">
          <h3>Endereço</h3>
          <p>{clienteSelecionado?.endereco?.logradouro} - {clienteSelecionado?.endereco?.numero} {clienteSelecionado?.endereco?.complemento ?? ""}</p>
          <p>{clienteSelecionado?.endereco?.bairro} - {clienteSelecionado?.endereco?.cidade} - {clienteSelecionado?.endereco?.uf}</p>
          <p><strong>CEP:</strong> {formatCEP(clienteSelecionado?.endereco?.cep)}</p>
        </div>

        <div className="modal-card">
              <h3>Informações Fiscais</h3>
        
          <p><strong>Inscrição Municipal:</strong> {clienteSelecionado?.im ?? "-"}</p>
          <p><strong>Inscrição Estadual:</strong> {clienteSelecionado?.ie ?? "-"}</p>
          <p><strong>Limite Faturamento:</strong> {clienteSelecionado?.faixaFaturamento != null
            ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(clienteSelecionado?.faixaFaturamento)
            : "-"}</p>
          <p><strong>Tipo de Empresa:</strong> {clienteSelecionado?.tipoEmpresa}</p>
          <p><strong>Enquadramento:</strong> {clienteSelecionado?.enquadramento}</p>
          <p><strong>Regime Tributário:</strong> {clienteSelecionado?.regimeTributario}</p>
          <p><strong>Segmento:</strong> {clienteSelecionado?.segmentoEmpresa}</p>
        </div>

        <div className="modal-card">
          <h3>Serviço de Contabilidade</h3>
          <p><strong>Data Início:</strong> {clienteSelecionado?.servico?.dataInicio}</p>
          <p><strong>Situação:</strong> {clienteSelecionado?.servico?.situacao?.id === "A" ? "ATIVO" : "INATIVO"}</p>
          <p><strong>Valor Mensal:</strong> {clienteSelecionado?.servico?.valorMensal != null
            ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(clienteSelecionado.servico.valorMensal)
            : "-"} (
            {clienteSelecionado?.servico?.valorAssinatura != null
              ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(clienteSelecionado.servico.valorAssinatura)
              : "-"} +
            {clienteSelecionado?.servico?.valorAdicional != null
              ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(clienteSelecionado.servico.valorAdicional)
              : "-"})
          </p>
        </div>
      </div>

      <Modal
        open={isModalAtualizarDadosEmptresa}
        title={"Dados da Empresa"}
        onCancel={() => setIsModalAtualizarDadosEmptresa(false)}
        width="1100px"
        footer={null}
      >
        <AtualizarDadosEmpresa clienteSelecionado={clienteSelecionado.id}/>
      </Modal>
    </>
  );
};

export default DadosEmpresa;
